<script lang="ts">
  import SessionsSection from "../../../../_modules/sessions-section"

  const props = $props()
</script>

<SessionsSection {...props} />
